import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import { GPK_PEGAWAI_PERENCANAAAN_STATUS_LABELS } from 'app/KinerjaGpkPage/constants/contents'

import type { KinerjaStatusGpk } from 'types/kinerja-gpk'

type PerencanaanStatusBadgeProps = {
  status: KinerjaStatusGpk
}

const BADGE_VARIANTS: Record<KinerjaStatusGpk, BadgeProps['variant']> = {
  NOT_FOUND: 'neutral',
  DRAFT: 'neutral',
  WAITING_APPROVAL: 'informational',
  WAITING_APPROVAL_PPK: 'informational',
  REVISION_TK: 'warning',
  REVISION_PPK: 'warning',
  APPROVED: 'success',
  READY: 'success',
}

export function PerencanaanStatusBadge({
  status,
}: PerencanaanStatusBadgeProps) {
  const label = GPK_PEGAWAI_PERENCANAAAN_STATUS_LABELS[status]
  const badgeVariant = BADGE_VARIANTS[status]

  if (!label) return null

  return <Badge variant={badgeVariant}>{label}</Badge>
}
